import { Box } from '@mui/material';
import { BaseAccordion } from '../../../../../Accordion/BaseAccordion';
import { ValidationBadge } from '../../ValidationBadge/ValidationBadge';
import { useMultiColumnRulesWithCategoriesSection } from './useMultiColumnRulesWithCategoriesSection';
import { MultiColumnRulesWithCategoriesSectionProps } from './types';
import { CategorySection } from './components/CategorySection/CategorySection';
import './MultiColumnRulesWithCategoriesSection.scss';

export const MultiColumnRulesWithCategoriesSection = (
  props: MultiColumnRulesWithCategoriesSectionProps
) => {
  const { validationResult } = useMultiColumnRulesWithCategoriesSection(props);

  return (
    <BaseAccordion
      title={props.title}
      expanded={props.expanded}
      onChange={props.onChange}
      className="multiColumnRulesWithCategoriesSection"
      badge={<ValidationBadge validationResult={validationResult} />}
    >
      <Box>
        {/* Category Sections - Grid layout */}
        <Box className="categorySections">
          {props.categories.map(category => (
            <CategorySection
              key={category.id}
              category={category}
              sectionId={props.sectionId}
              templateId={props.templateId}
              instrumentType={props.instrumentType}
              availableHeaders={props.availableHeaders || []}
            />
          ))}
        </Box>
      </Box>
    </BaseAccordion>
  );
};
